import React from 'react'
import { Card, Button, Row, Col } from 'react-bootstrap'

const AgentInstaller = () => {
  return (
    <Row>
      <Col className='d-flex justify-content-center'>
        <Card style={{ width: '20rem' }}>
          <Card.Img style={{ margin: '10px', alignSelf: 'center', width: '100px', height: '100px' }} variant="top" src="https://pinotagermm.centrastage.net/assets/401ce54b.png" />
          <Card.Body>
            <Card.Title>Windows agent</Card.Title>
            <Card.Text>
            </Card.Text>

            <Button variant="primary">Download and install the agent</Button>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  )
}

export default AgentInstaller
